<div class="flex">
  <div class="flex flex-col w-full gap-4">
    <section class="flex flex-col gap-4">
      <elcia-label [label]="'timesheet.sections.general' | translate"/>

      <div class="flex gap-2">
        <div class="flex-1">
          <elcia-text-input [control]="timesheetForm.controls.subject" [label]="'timesheet.subject' | translate"/>
        </div>
      </div>

      <div class="flex gap-2">
        <div class="flex-1">
          <elcia-timesheet-type-dropdown [control]="timesheetForm.controls.timesheetTypeId" [isMulti]="false"/>
        </div>
        <div class="flex-[2]">
          <elcia-activity-type-dropdown [control]="timesheetForm.controls.activityTypeIds" [isMulti]="true"/>
        </div>
      </div>

      <div class="flex gap-2">
        <div class="flex-1">
          <elcia-timesheet-status-dropdown [control]="timesheetForm.controls.statusId" [isMulti]="false"/>
        </div>
        <div class="flex-1">
          <elcia-date-picker [control]="timesheetForm.controls.date" [label]="'timesheet.date' | translate"/>
        </div>
      </div>

      <div class="flex gap-2">
        <div class="flex-1">
          <elcia-party-dropdown [control]="timesheetForm.controls.concernedPartyId" [partyTypes]="partyTypes()"/>
        </div>
        <div class="flex-1">
          <elcia-product-dropdown [control]="timesheetForm.controls.productIds"
                                  [isMulti]="true"
                                  [productType]="ProductType.MODULE"/>
        </div>
      </div>
    </section>

    <p-divider/>

    <section class="flex flex-col gap-4">
      <elcia-label [label]="'timesheet.sections.time-and-billing' | translate"/>

      <div class="flex gap-2">
        <div>
          <elcia-time-picker [control]="timesheetForm.controls.startTime" [label]="'timesheet.start' | translate"/>
        </div>
        <div>
          <elcia-time-picker [control]="timesheetForm.controls.endTime" [label]="'timesheet.end' | translate"/>
        </div>
        <div>
          <elcia-numeric-input [control]="timesheetForm.controls.durationInMinutes"
                               [label]="('timesheet.duration' | translate) + ' (' + ('app.minutes' | translate) + ')'"
                               [suffix]="'min'"/>
        </div>
        <div class="w-auto flex items-center">

          <elcia-toggle-switch [control]="timesheetForm.controls.isBillable"
                               [label]="'timesheet.billable' | translate"/>
        </div>
        @if (timesheetForm.controls.isBillable.value) {
          <div>
            <elcia-numeric-input [control]="timesheetForm.controls.billableDurationInMinutes"
                                 [label]="('timesheet.billable-duration' | translate)  + ' (' + ('app.minutes' | translate) +')'"
                                 [min]="15"
                                 [suffix]="'min'"/>
          </div>
        }
      </div>


    </section>

    <span *canAccessFinances>
      @if (hasTravelExpenses()) {
        <p-divider/>

        <section class="flex flex-col gap-4">
          <elcia-label [label]="'timesheet.sections.travel' | translate"/>

          <div class="flex items-center gap-2">
            <div>
              <elcia-numeric-input [control]="timesheetForm.controls.mileage"
                                   [label]="'timesheet.mileage' | translate"
                                   [suffix]="' km'"/>
            </div>
            <elcia-button (onClick)="calculateDistance()"
                          [disabled]="timesheetForm.controls.concernedPartyId.value == null"
                          [icon]="'AI'"
                          [isLoading]="travelDistanceMutation.isPending()"
                          [label]="'Auto'"
                          [severity]="'secondary'"
                          [variant]="'outlined'"/>
            @if (travelDistanceMutation.data()) {
              <elcia-button (onClick)="openItinerary()"
                            [icon]="'map'"
                            [severity]="'secondary'"
                            [variant]="'outlined'"/>
            }
            <div>
              <elcia-numeric-input [control]="timesheetForm.controls.travelExpensesAmount"
                                   [label]="'timesheet.travel-expenses-amount' | translate"
                                   [suffix]="' €'"/>
            </div>
          </div>
        </section>
      }
    </span>

    <p-divider/>

    <section class="flex flex-col gap-4">
      <elcia-label [label]="'timesheet.sections.descriptions-and-documents' | translate"/>
      <div>
        <elcia-text-area [control]="timesheetForm.controls.description" [label]="'timesheet.description' | translate"/>
      </div>

      @if (timesheetForm.controls.isBillable.value) {
        <div *canAccessFinances>
          <elcia-text-area [control]="timesheetForm.controls.billingDescription"
                           [label]="'timesheet.billing-description' | translate"/>
        </div>
      }

      <elcia-document-uploader
        (onDelete)="markForDeletion($event)"
        (onDownload)="downloadDocument($event)"
        (onFilesSelected)="addPendingFiles($event)"
        (onRemovePendingFile)="removePendingFile($event)"
        [documents]="displayedDocuments()"
        [pendingFiles]="pendingFiles()"
      />

      @if (currentUserService.hasTodoAccess()) {
        <div class="flex justify-end">
          <elcia-button (onClick)="togglePicker()" [icon]="'todo'"
                        [label]="('entity.todo' | translate) + (this.timesheetForm.controls.todoId.value != null ? ' (1)' : '')"
                        [severity]="'secondary'"
                        [variant]="(this.timesheetForm.controls.todoId.value != null) ? 'outlined' : 'text'"/>
        </div>
      }
    </section>
  </div>

  @if (isTodoPickerDisplayed() && currentUserService.hasTodoAccess()) {
    <p-divider layout="vertical"/>
    <div [animate.enter]="'slide-in-right'" class="flex flex-col">
      <elcia-todo-picker (onTodoSelect)="selectTodo($event)" [control]="timesheetForm.controls.todoId"/>
    </div>
  }
</div>
